//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    ifAddEdit: {
      type: Boolean,
      default: false
    },
    AddformData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    systemdata: null
  },
  data: function data() {
    return {
      formPower: {
        dictGroupCode: null,
        dictGroupName: null,
        systemId: null
      },
      systemname: '',
      roleRules: {
        sysName: [{
          required: true,
          message: '请选择系统的名称',
          trigger: 'change'
        }],
        roleNum: [{
          required: true,
          message: '请输入角色的编号',
          trigger: 'blur'
        }],
        roleName: [{
          required: true,
          message: '请选择角色的名称',
          trigger: 'change'
        }]
      },
      specificUserRules: {
        userName: [{
          required: true,
          message: '请输入用户的名称',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择是否是AB角',
          trigger: 'change'
        }],
        roleDep: [{
          required: true,
          message: '请选择角色生效的部门',
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    cancelDailog: function cancelDailog() {
      this.$emit('DictandVirtualSubmit', {
        bool: false
      });
    },
    commit: function commit() {
      //  this.$refs.formPower.validate((valid,object) => {
      //    console.log("valid",valid);
      //    console.log("object",object);
      //    console.log(formName,"formNameformName");
      //   if (valid) {
      this.$emit('DictandVirtualSubmit', {
        bool: true,
        formData: this.formPower
      });
      // } else {
      //   console.log('error submit!!');
      //   return false;
      // }
      // });
    },
    selectchange: function selectchange() {
      // console.log(value,"asasds");
    }
  }
};